import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});

class dashboardService {
  getAdminDashboard() {
    return instance.get("/dashboard");
  }
  getOcsbDashboard() {
    return instance.get("/ocsb/dashboard");
  }
  getOcsbFarmers(body) {
    return instance.post("/ocsb/farmers", body);
  }
  getSumByDopa() {
    return instance.get("/ocsb/dopa");
  }
  getSumByAssocMembers() {
    return instance.get("/ocsb/members");
  }
  getSumByRegistration() {
    return instance.get("/ocsb/reg");
  }
  getAssocByFarmer(id) {
    return instance.get("/ocsb/assoc/farmer/" + id);
  }
  getContractByFarmer(id) {
    return instance.get("/ocsb/contract/farmer/" + id);
  }
  getFrontpageDashboard() {
    return instance.get("/regsugar/frontpage/");
  }
  getAssocDashboard() {
    return instance.get("/association/dashboard/");
  }
  getSumByAssociationId(id) {
    return instance.get("/association/dashboard/" + id);
  }
}

export default new dashboardService();
